import "./Profile.css";

function Profile({ url }) {
  return (
    <img
      src={url}
      alt="profile"
      className="profile-avatar"
    />
  );
}

export default Profile;
